import DatasetsPage from 'modules/ai-inventory/datasets/Main';
import AISystem from 'modules/ai-inventory/ai-system/Main';
import AISolutions from 'modules/ai-inventory/ai-system/add-ai-solutions/Main';
import RecordAISystem from 'modules/ai-inventory/ai-system/ai-systems-detail/Main';
import RecordDataset from 'modules/ai-inventory/datasets/records-dataset/Main';
import SensitivityPage from 'modules/ai-inventory/sensitivy-types/Main';
import DiscoveryAIPage from 'modules/ai-inventory/discovery-ai/Main';
import AIInventoryWrapper from 'modules/ai-inventory/components/AIInventoryWrapper';
import FormDataSets from 'modules/ai-inventory/datasets/form-dataset/Main';
import FormSourceTypes from 'modules/ai-inventory/ai-system/form-source-type/Main';
import MCPServer from 'modules/ai-inventory/mcp-servers/Main';
import RecordMCPServer from 'modules/ai-inventory/mcp-servers/records-server/Main';
import FormMCPServers from 'modules/ai-inventory/mcp-servers/form-dataset/Main';
// import UserSecurityPage from 'modules/home/manage-clients/dashboard/usersettings/UserSecurityPage';

const AIInventoryRoutes = (): any => ({
  path: '',
  element: <AIInventoryWrapper />,
  children: [
    {
      path: 'ai-systems',
      element: <AISystem />,
    },
    {
      path: 'ai-systems/add',
      element: <AISolutions />,
    },
    {
      path: 'ai-systems/edit/:aiSystemId',
      element: <FormSourceTypes purpose="edit" />,
    },
    { path: 'ai-systems/form-source-type', element: <FormSourceTypes /> },
    {
      path: 'ai-systems/records/:aiSystemId',
      element: <RecordAISystem />,
    },
    {
      path: 'datasets',
      element: <DatasetsPage />,
    },
    {
      path: 'datasets/new',
      element: <FormDataSets />,
    },
    {
      path: 'datasets/edit/:recordId',
      element: <FormDataSets purpose="edit" />,
    },
    {
      path: 'datasets/records/:recordId',
      element: <RecordDataset />,
    },
    {
      path: 'sensitivity-types',
      element: <SensitivityPage />,
    },
    {
      path: 'sensitivity-types',
      element: <SensitivityPage />,
    },
    {
      path: 'discovery-ai',
      element: <DiscoveryAIPage />,
    },
    {
      path: 'mcp-servers',
      element: <MCPServer />,
    },
    {
      path: 'mcp-servers/records/:mcpId',
      element: <RecordMCPServer />,
    },
    {
      path: 'mcp-servers/new',
      element: <FormMCPServers />,
    },
    {
      path: 'mcp-servers/edit/:mcpId',
      element: <FormMCPServers purpose="edit" />,
    },
    // {
    //     path: 'security',
    //     element: <UserSecurityPage />,
    // },
  ],
});

export default AIInventoryRoutes;
